import angular from "angular";

angular
    .module('mobiusControl.mobiusHandler', [])
    .service('MobiusHandler', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/mobius/handlers';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.destroy = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'})
        };

        this.toggleByParams = function (params) {
            return $http.post(uri(null, 'toggle-by-params'), params);
        };



    }]);

export default 'mobiusControl.mobiusHandler';


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-handler.js